import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { EmptyState } from './ui';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-dvh items-center justify-center text-[13px] text-muted" aria-busy="true">
        Oturum kontrol ediliyor…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}

/** Sahip olmayan ajanlar için yönetim ekranlarını kapatır (PLAN §8.6). */
export function RequireRole({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  if (user?.role !== 'owner') {
    return (
      <EmptyState
        icon="lock"
        title="Bu ekran için sahip yetkisi gerekir"
        hint="Ajan rolüyle giriş yaptınız. Erişim için sahip hesabıyla giriş yapın veya bir sahipten yetki isteyin."
      />
    );
  }

  return <>{children}</>;
}
